(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/tabs/views/tabs.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/tabs/views/tabs.js'); 

(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.tabs.views.Tabs = Backbone.Marionette.View.extend({
    className: 'tab-stick-container js-tab-stick-container-original',
    template: function(data) {
      return svs.app.product_start_page.templates.tabs(data);
    },
    ui: {
      playButton: '.js-product-start-page-tab-button-play',
      tab: '.js-tab',
      tabs: '.js-tab li'
    },
    events: {
      'click @ui.playButton': 'buttonPlayClick',
      'click @ui.tabs': 'tabClick'
    },
    currentTabAnchor: null,
    onRender: function() {
      var tab = this.$el.find('.js-tab li').first();
      tab.addClass('active');
      this.$el
        .find('.js-tab-pane')
        .first()
        .addClass('active');

      this.currentTabAnchor = tab.data('anchor');
      this.tabWidgets = {};

      var containerBranding =
        'tab-stick-container-' +
        (this.model.get('generalSettings') ?
          this.model.get('generalSettings').branding :
          'inverted');
      var tabBranding =
          'tab-' +
          (this.model.get('generalSettings') ?
            this.model.get('generalSettings').branding :
            'inverted');

      if (
        this.model.get('generalSettings') &&
        this.model.get('generalSettings').branding &&
        (this.model.get('generalSettings').branding === 'stryktipset' ||
          this.model.get('generalSettings').branding === 'europatipset' ||
          this.model.get('generalSettings').branding === 'extratipset' ||
          this.model.get('generalSettings').branding === 'topptipset' ||
          this.model.get('generalSettings').branding === 'maltipset' ||
          this.model.get('generalSettings').branding === 'grasroten' || 
          this.model.get('generalSettings').branding === 'arenan' || 
          this.model.get('generalSettings').branding === 'oddset' ||
          this.model.get('generalSettings').branding === 'own-rows' ||
          this.model.get('generalSettings').branding === 'poker')
      ) {
        this.$el.addClass('tab-stick-container-' + this.model.get('generalSettings').branding);

        containerBranding = 'tab-stick-container-inverted';
        tabBranding = 'tab-inverted';
      }

      this.$el.addClass(containerBranding);
      this.$el.find('.js-tab').addClass(tabBranding);
    },
    onAttach: function() {
      var tabAnchor = svs.utils.url.queryString.flik;

      if (tabAnchor) {
        this.currentTabAnchor = tabAnchor;
        this.setActiveTab(tabAnchor);
      } else {
        this.loadTabContent(this.$el.find('.js-tab li').first());
      }
    },
    onDestroy: function() {
      svs.components.tab.dispose();
    },
    setActiveTab: function(tabAnchor) {
      var tab = this.$el.find('.js-tab li[data-anchor=' + tabAnchor.toLowerCase() + ']');
      $(window).trigger('setActiveTab', tab);
      this.tabClick({ currentTarget: tab });
    },
    loadTabContent: function(tab) {
      var tabName = tab.data('tab');
      var area = tab.data('widget');
      var tabContent = $('#' + tabName);
      var widgetAreaLegacy = !svs.core.detect.feature('ft-product-start-fullwidth') ?
          'widget-area-inline widget-area-legacy' :
          undefined;

      if (area && !Object.prototype.hasOwnProperty.call(this.tabWidgets, area)) {
        this.tabWidgets[area] = true;

        svs.components.loader.show();

        svs.core.widget_area.loadArea(area, widgetAreaLegacy, function(safeString) {
          svs.components.loader.hide();

          tabContent.html(safeString ? safeString.string : '');

          var firstImage = tabContent.find('.js-responsive-image').first();
          setTimeout(function() {
            firstImage.hide().show();
          }, 100);
        });
      }
    },
    tabClick: function(e) {
      var tabEl = $(e.currentTarget);
      var tabAnchor = tabEl.data('anchor');
      var tabTitle = tabEl.text();

      this.loadTabContent(tabEl);

      if (this.currentTabAnchor !== tabAnchor) {
        this.currentTabAnchor = tabAnchor;

        if (tabAnchor) {
          var url = this.updateQueryStringParameter(
            window.location.search,
            'flik',
            tabAnchor
          );

          history.replaceState(null, tabTitle, url);
        }

        if (this.options.model.get('resizeTabWhenClick')) {
          setTimeout(function() {
            $(window.document).trigger('resizeTabView');
          }, 0);
        }
      }
    },
    buttonPlayClick: function() {
      $('html, body').animate({ scrollTop: 0 }, 1000);
    },
    lateInit: function() {
      if (this.options.model.get('dontStickIt') !== true) {
        svs.components.tab.stickIt();
      }
      svs.components.tab.autoCollapse();
    },
    updateQueryStringParameter: function(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = uri.indexOf('?') !== -1 ? '&' : '?';

      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
      }
      return uri + separator + key + '=' + value;
    }
  });
})(Backbone, _, svs);

 })(window);